import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { post, get } from "./libs/axios";
import Util from "./libs/util";
import md5 from "js-md5";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI);

Vue.config.productionTip = false; //阻止启动生产消息

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.util = Util;
Vue.prototype.$md5 = md5;
// 每次保持在头部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
router.onError((err) => {
  const targetPath = router.history.pending.fullPath;
  if (
    JSON.stringify(err).indexOf("Loading chunk") > -1 ||
    err.indexOf("Loading chunk") > -1
  ) {
    router.replace(targetPath);
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
